export const Users = [
  {
    id:1,
    profilePicture: "../assets/person/1.jpeg",
    username: "Tazriyan",
  },
  {
    id:2,
    profilePicture: "../assets/person/2.jpg",
    username: "Samir",
  },
  {
    id:3,
    profilePicture: "../assets/person/3.jpg",
    username: "Leanur Rahman",
  },
  {
    id:4,
    profilePicture: "../assets/person/4.jpg",
    username: "Safa Rahman",
  },
  {
    id:5,
    profilePicture: "../assets/person/5.jpg",
    username: "Fazle Rabbi",
  },
  {
    id:6,
    profilePicture: "../assets/person/6.jpg",
    username: "Efaz Ahmed",
  },
  {
    id:7,
    profilePicture: "../assets/person/7.jpg",
    username: "Wahed Shawn",
  },
  {
    id:8,
    profilePicture: "../assets/person/8.jpg",
    username: "Arjon Babu",
  },
  {
    id:9,
    profilePicture: "../assets/person/9.jpg",
    username: "Sheikh Mujibur Rahman",
  },
  {
    id:10,
    profilePicture: "../assets/person/10-abir.jpg",
    username: "Ishrak Abir",
  },
];

export const Posts = [
  {
    id: 1,
    desc: " :)   A month has passed. The wound remains unanswered.",
    photo: "../assets/post/1p.jpg",
    date: "5 mins ago",
    userId: 8,
    like: 32,
    comment: 9,
  },
  {
    id: 2,
    photo: "../assets/post/2p.jpg",
    date: "15 mins ago",
    userId: 2,
    like: 2,
    comment: 1,
  },
  {
    id: 3,
    desc: "Every moment is a fresh beginning.",
    photo: "../assets/post/3.jpeg",
    date: "1 hour ago",
    userId: 3,
    like: 61,
    comment: 2,
  },
  {
    id: 4,
    photo: "../assets/post/4.png",
    date: "4 hours ago",
    userId: 4,
    like: 7,
    comment: 3,
  },
  
  {
    id: 6,
    photo: "../assets/post/6p.jpg",
    date: "1 day ago",
    userId: 6,
    like: 44,
    comment: 6,
  },
  {
    id: 7,
    desc: "Never regret anything that made you smile.",
    photo: "../assets/post/7p.jpg",
    date: "2 days ago",
    userId: 7,
    like: 52,
    comment: 3,
  },
  {
    id: 8,
    photo: "../assets/post/8.jpeg",
    date: "3 days ago",
    userId: 8,
    like: 15,
    comment: 1,
  },
  {
    id: 9,
    desc: "Change the world by being yourself.",
    photo: "../assets/post/9.jpeg",
    date: "5 days ago",
    userId: 9,
    like: 11,
    comment: 2,
  },
  {
    id: 10,
    desc: "Love For All, Hatred For None.",
    photo: "../assets/post/10p.jpg",
    date: "1 week ago",
    userId: 10,
    like: 104,
    comment: 12,
  },
];
